import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';

import { PREVENTIVE_TASK_ASSIGNEE_PATH } from '../../../../config/paths';

import {
  clearPreventiveTaskAssignee,
  getPreventiveTaskAssignee,
} from '../../../../actions/task-schedule/PreventiveTaskAssignee';

import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';

import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import InternalResource from '../../../common/resource/InternalResource';
import PreventiveTaskAssigneeBasicInformationResource from './resource/PreventiveTaskAssigneeBasicInformationResource';
import PreventiveTaskAssigneeToolbar from './PreventiveTaskAssigneeToolbar';

export const PreventiveTaskAssignee = ({
  breadcrumbs,
  dispatchGetPreventiveTaskAssignee,
  dispatchClearPreventiveTaskAssignee,
  match: {
    params: { id: preventiveTaskAssigneeId },
  },
  loading,
  preventiveTaskAssignee,
}) => {
  useLayoutEffect(() => {
    dispatchGetPreventiveTaskAssignee({ preventiveTaskAssigneeId });

    return () => dispatchClearPreventiveTaskAssignee();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (preventiveTaskAssignee.isEmpty())
    content = <NoDataResource returnPage={PREVENTIVE_TASK_ASSIGNEE_PATH} />;
  else {
    const preventiveTaskAssigneeJson = preventiveTaskAssignee.toJS();

    content = (
      <>
        <h3>Información de Asignación</h3>
        <PreventiveTaskAssigneeBasicInformationResource
          {...preventiveTaskAssigneeJson}
        />

        <InternalResource
          id={preventiveTaskAssigneeJson.id}
          createDate={preventiveTaskAssigneeJson.createDate}
          lastUpdate={preventiveTaskAssigneeJson.lastUpdate}
        />
      </>
    );

    toolbar = (
      <PreventiveTaskAssigneeToolbar
        preventiveTaskAssigneeId={preventiveTaskAssigneeJson.id}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Asignación de Tarea Programada"
      content={content}
    />
  );
};

PreventiveTaskAssignee.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearPreventiveTaskAssignee: PropTypes.func.isRequired,
  dispatchGetPreventiveTaskAssignee: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  preventiveTaskAssignee: PropTypes.instanceOf(Immutable.Map).isRequired,
};

PreventiveTaskAssignee.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearPreventiveTaskAssignee: clearPreventiveTaskAssignee,
  dispatchGetPreventiveTaskAssignee: getPreventiveTaskAssignee,
};

const mapStateToProps = (
  { TaskScheduleUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...TaskScheduleUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Asignaciones Tareas Programadas',
      href: PREVENTIVE_TASK_ASSIGNEE_PATH,
    },
    {
      text: 'Ver',
      href: `${PREVENTIVE_TASK_ASSIGNEE_PATH}/${id}`,
    },
  ],
  preventiveTaskAssignee: TaskScheduleUnit.PreventiveTaskAssignee.getIn([
    'current',
    'content',
  ]),
  loading: !TaskScheduleUnit.PreventiveTaskAssignee.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PreventiveTaskAssignee);
